import { gql } from '@apollo/client'

export const GET_RECOMMENDED_AGE_BY_SLUG = gql`
  query getRecommendedAgeBySlug($slug: String!) {
    project(slug: $slug) {
      id
      title {
        ... on Node {
          id
        }
        ... on ContentVotingResult {
          recommendedAge {
            age
          }
        }
      }
    }
  }
`
